import { Switch, Route } from 'react-router-dom';

import { useFeature } from 'FeatureProvider';

import { EmployeesListPage } from 'domains/personnel';
import { LicenseGuard } from 'domains/subscription';

import NotFound from 'components/NotFound';
import useUserStore from 'hooks/useUserStore';

import AppRoute from '../PrivateRoute';
import { EmployeeCreatePage } from 'domains/personnel/presentation/pages/employees/create/page';
import { EmployeeEditPage } from 'domains/personnel/presentation/pages/employees/[uuid]/page';

/**
 * Employees Routes
 *
 * Route configuration for the Employees domain.
 * Manages all employee-related pages and navigation.
 * Uses AppRoute for authentication, permissions, and layout.
 *
 * @returns {React.ReactElement} Employees router component
 */
export const EmployeesRoutes = (): React.ReactElement => {
  const {
    storeState: { selected: storeSelected },
  } = useUserStore();
  const superUserAccess = useFeature('adminStore');
  const workforceModuleAccess = useFeature('backofficeModuleWorkforce');
  const permissionWorkforceModule = (superUserAccess || workforceModuleAccess) && !storeSelected?.isDraft;

  return (
    <LicenseGuard>
      <Switch>
        {/* Employees List - Main page */}
        <AppRoute accessRoute={permissionWorkforceModule} component={EmployeesListPage} exact path="/employees" />
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={EmployeeCreatePage}
          exact
          path="/employees/create"
        />

        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={EmployeeEditPage}
          exact
          path="/employees/:employeeUuid/edit"
        />

        {/* TODO: Add more routes as needed
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={EmployeeFormPage}
          exact
          path="/employees/create"
        />
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={EmployeeFormPage}
          path="/employees/:employeeUuid/edit"
        />
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={EmployeeDetailsPage}
          path="/employees/:employeeUuid"
        />
        */}

        {/* Not found */}
        <Route component={NotFound} />
      </Switch>
    </LicenseGuard>
  );
};
